<template>
    <div name="home" class="mobile">
        <banner />
        <reason />
        <soldoc-use />
        <moisture />
        <download />
        <footer-page />
        <!-- <popup/> -->

    </div>
</template>

<script>
import Banner from '@/components/Banner';
import Reason from '@/components/Reason';
import SoldocUse from '@/components/SoldocUse';
import Moisture from '@/components/Moisture';
import Download from '@/components/Download';
import FooterPage from '@/components/FooterPage';
import Popup from '@/components/Popup'

export default {
    name: 'home',
    components: {
        Banner,
        Reason,
        SoldocUse,
        Moisture,
        Download,
        FooterPage,
        Popup
    }
}
</script>

<style scoped>
    .mobile {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        overflow: hidden;
        position: relative;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Home.vue